export const socialsData = {
    github: 'https://github.com/haronsoft/',
    facebook: 'https://github.com/haronsoft//',
    linkedIn: 'https://www.linkedin.com/in/haron-njuguna/',
    twitter: 'https://twitter.com/haron_soft',
    medium: 'https://www.linkedin.com/in/haron-njuguna/',
    stackOverflow: 'https://www.linkedin.com/in/haron-njuguna/',
    mail: 'harondev.net@gmail.com', 
}